import { Button } from "antd";
import styled from "styled-components";

import { SecondaryText } from "@/shared/ui/Typography";

export const StyledODHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
`;

export const StyledODTable = styled.div`
    margin-top: 16px;
    margin-bottom: 16px;
    border-radius: 4px;
    && {
        background-color: ${(props) => props.theme.collapseHeaderBackground};
    }
`;

export const StyledODTableHeader = styled.div`
    padding: 12px 16px;
    display: grid;
    grid-template-columns: 1fr 1fr 1.5fr;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};
`;

export const StyledODTableHeaderItem = styled(SecondaryText)`
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    text-align: center;
    width: 100%;
    border-right: 1px solid ${(props) => props.theme.secondaryBorderColor};

    &:last-child {
        border-right: none;
    }
`;

export const StyledODTableBody = styled.div`
    padding: 16px 12px;
`;

export const StyledODMoreProductsButton = styled(Button)`
    text-decoration: underline;
`;
